import { z } from 'zod';

/** ISO-8601 timestamps arrive as strings; parsed where they are used. */
const IsoDate = z.string();

export const TokenType = z.enum(['access', 'two_factor']);

/** POST /auth/login — phase 0 B2 body. Either an access token or a pending 2FA token. */
export const LoginResponse = z.looseObject({
  id: z.number().optional(),
  name: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  phone: z.string().nullable().optional(),
  role: z.number().optional(),
  token: z.string(),
  tokenExpiryDate: IsoDate,
  tokenType: TokenType,
  twoFactorConfigurationRequired: z.boolean().optional(),
  verificationType: z.string().nullable().optional(),
  teams: z
    .array(z.looseObject({ id: z.number().optional(), name: z.string().optional() }))
    .optional()
});
export type LoginResponse = z.infer<typeof LoginResponse>;

const TwoFactorConfigureBody = z.looseObject({
  qrUrl: z.string().nullable().optional(),
  secretKey: z.string().nullable().optional(),
  recoveryCodes: z.array(z.string()).optional(),
  isSmsFallback: z.boolean().optional(),
  phone: z.string().nullable().optional()
});
/** The backend answers the plain string "SMS fallback in use" for SMS; normalised to an object. */
export const TwoFactorConfigureResponse = z
  .union([TwoFactorConfigureBody, z.string()])
  .transform((value): z.infer<typeof TwoFactorConfigureBody> =>
    typeof value === 'string' ? { isSmsFallback: true } : value
  );
export type TwoFactorConfigureResponse = z.infer<typeof TwoFactorConfigureResponse>;

export const TwoFactorVerifyResponse = LoginResponse.extend({
  clientDeviceId: z.string().nullable().optional(),
  recoveryCodes: z.array(z.string()).optional()
});
export type TwoFactorVerifyResponse = z.infer<typeof TwoFactorVerifyResponse>;
